import React from 'react';

import classes from './ModalImageViewer.css';


const modalImageViewer = props => {
    return (
        <div className={classes.ImageViewer}>
             <img
                className={classes.Image}
                src={props.image}
                alt="not found"/>
        </div>
    )
}

export default modalImageViewer


// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalImageViewer/ModalImageViewer.js